<script>

    import { toast } from 'bulma-toast'
    import { noticesStore, modalStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import NoticesService from '../$services/notices.service'
    import DateMethods from '../$methods/date.methods'

    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'

    export let query = {}

    let loading = false

    $: createPermission = query.userId ? 'UsersView.Notice.Create' : 'SettingsView.Notice.Create'
    $: queryKey = JSON.stringify(query)
    $: if (queryKey) getNotices()

    async function getNotices() {

        loading = true
        const resp = await NoticesService.getNotices(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        noticesStore.set(resp.data)
    }

</script>

<Table items={ $noticesStore.length } { loading } skeletonCols={8}>
    <div slot="header" class="header-filters">
        {#if isPermission($adminStore, createPermission)}
            <div class="header-top">
                <ButtonModal modalId="notice_create_modal" text="Agregar" icon="plus" />
            </div>
        {/if}
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-heading"></i></span>
                    <span>Título</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-tag"></i></span>
                    <span>Tipo</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-desktop"></i></span>
                    <span>Display</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-sort-amount-up"></i></span>
                    <span>Prioridad</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar-plus"></i></span>
                    <span>Creación</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-calendar-times"></i></span>
                    <span>Expiración</span>
                </span>
            </th>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                    <span>Acciones</span>
                </span>
            </th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each $noticesStore as notice, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ notice.title }</td>
                <td>{ notice.type }</td>
                <td>{ notice.display }</td>
                <td>{ notice.index }</td>
                <td>{ DateMethods.dateLarge(notice.created) }</td>
                <td>{ DateMethods.dateLarge(notice.expired) }</td>
                <td>
                    <Button on:click={() => modalStore.open('notice', 'modal', notice)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
